import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import 'foundation-sites/dist/css/foundation.min.css'
import Storage from 'vue-ls'
import { store } from './store'
import router from './router'

function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const options = {
  namespace: 'tnmtool__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
}

Vue.use(Storage, options)

Vue.config.productionTip = false

Vue.prototype.$store = store
Vue.prototype.$http = Axios
Vue.prototype.$sleep = sleep

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
